import React, { useState } from 'react';

// Hooks
import { useReviewTemplate } from 'Shared/utils/hooks/use-review-template';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { WpFormLayout } from 'Wpds/components/form';

// Styles
import './ReviewTemplateBuilderDetails.scss';

type Props = {
  slug: string;
};

const ReviewTemplateBuilderDetails = ({ slug }: Props) => {
  const { template, handleUpdateTemplateWithDebounce } = useReviewTemplate({ slug, withFetch: false });

  const [name, setName] = useState(template?.name || 'Untitled');
  const [description, setDescription] = useState(template?.description);

  const handleNameOnChange = (value: string) => {
    setName(value);
    handleUpdateTemplateWithDebounce({ reviewTemplate: { ...template, name: value } });
  };

  const handleDescriptionOnChange = (value: string) => {
    setDescription(value);
    handleUpdateTemplateWithDebounce({ reviewTemplate: { ...template, description: value } });
  };
  const baseClassName = 'ReviewTemplateBuilderDetails';

  return (
    <WpContainer className={baseClassName}>
      <WpContainerBody>
        <WpFormLayout direction="vertical">
          <WpTextField
            id="name"
            label="Template name"
            value={name}
            placeholder="Enter a name for this template"
            onChange={handleNameOnChange}
            max={40}
          />
          <WpTextField
            id="description"
            label="Description"
            value={description}
            placeholder="Add a short description for this template"
            onChange={handleDescriptionOnChange}
            multiline={2}
            max={200}
          />
        </WpFormLayout>
      </WpContainerBody>
    </WpContainer>
  );
};

export default ReviewTemplateBuilderDetails;
